import {arrayHasContent} from "@/helpers/functions/arrays";

/*
* Receives comma seperated string of product codes
* and converts it to an array of product codes
*
* First remove html tags and spaces
* Then replace ; or [ENTER] with a comma
* Finally make an array (seperated on comma) and remove empty array values
*/
function convertProductCodesListToArray(productCodesList: string): string[] {
    if (productCodesList.length > 0) {
        const productsListNoHtmlAndSpaces = productCodesList.replace(/<br\s*\/?>/gi, ',').replace(/(<([^>]+)>)/gi, '').replaceAll(' ', ',') as string;
        const productsListAllCommas = productsListNoHtmlAndSpaces.replaceAll(';', ',').replaceAll('\n', ',').replaceAll('&nbsp', ',') as string;

        return productsListAllCommas.split(',').filter((product: string) => product !== '');
    }

    return [];
}

/*
* Checks if non-numeric characters exist in array of product codes
*
* Receives an array of product codes
* Returns a boolean; true if valid, false if invalid
*/
function cnkCodesArrayIsValid(productCodesArray: string[]): boolean {
    if (!arrayHasContent(productCodesArray)) {
        return true;
    }

    for (const productCode of productCodesArray) {
        if (!cnkCodeIsValid(productCode)) {
            return false;
        }
    }

    return true;
}

/*
* Checks if non-numeric characters exist in product code
*
* Receives a product codes string
* Returns a boolean; true if valid, false if invalid
*/
function cnkCodeIsValid(productCode: string): boolean {
    return (/^\d+$/).test(productCode);
}

/*
* Checks if product code is within custom cnk range
*
* Receives a product codes string
* Returns a boolean; true if valid, false if invalid
*/
function customProductCodeIsValid(productCode: string): boolean {
    return productCode.startsWith('9') || productCode.startsWith('09');
}


export {
    convertProductCodesListToArray,
    cnkCodesArrayIsValid,
    cnkCodeIsValid,
    customProductCodeIsValid
};
